/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum ValidationFaultPaymentDataErrorEnum {
  "PPT_SINTASSI_EXTRAXSD" = "PPT_SINTASSI_EXTRAXSD",

  "PPT_SINTASSI_XSD" = "PPT_SINTASSI_XSD",

  "PPT_DOMINIO_SCONOSCIUTO" = "PPT_DOMINIO_SCONOSCIUTO",

  "PPT_STAZIONE_INT_PA_SCONOSCIUTA" = "PPT_STAZIONE_INT_PA_SCONOSCIUTA"
}

/**
 * Fault codes for errors related to well-formed requests to ECs not present inside Nodo, should be mapped to 404 HTTP status code.
 * Most of the time these are generated when users input a wrong fiscal code or notice number.
 * For further information visit https://docs.pagopa.it/gestionedeglierrori/struttura-degli-errori/fault-code.
 * Possible fault codes are:
 * - `PPT_SINTASSI_EXTRAXSD`
 * - `PPT_SINTASSI_XSD`
 * - `PPT_DOMINIO_SCONOSCIUTO`
 * - `PPT_STAZIONE_INT_PA_SCONOSCIUTA`
 */

export type ValidationFaultPaymentDataError = t.TypeOf<
  typeof ValidationFaultPaymentDataError
>;
export const ValidationFaultPaymentDataError = enumType<
  ValidationFaultPaymentDataErrorEnum
>(ValidationFaultPaymentDataErrorEnum, "ValidationFaultPaymentDataError");
